<template lang="pug">
  .recommended-color.clearfix
    .color-product-info.xs-12
      img.color-image(:src="colorImageObj.url" :alt="colorImageObj.alt_text")
      .color-info
        span.color-name.color-slate.upper.xs-f-xsmall.lg-f-small.max-at-tweak {{ product.name }}
        span.color-description.xs-f-xsmall.lg-f-small.max-at-tweak {{ product.short_description }}

</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';

  export default {
    name: "RecommendedColor",

    inject: ['getObjProperty'],

    props: {
      product: {
        type: Object,
        required: true
      }
    },

    computed: {
      colorImageObj() {
        return this.getObjProperty(this.product, "imagery") || {};
      }
    }
  }
</script>

<style lang="stylus">
  .recommended-color
    .color-product-info
      padding 1.5em 0
      padding-top 1em
      .color-image
        display inline-block
        text-align left
        width 7em
        margin-right 1em
        @media mq-mobile
          width 5em
      .color-info
        display inline-block
        text-align left 
        vertical-align top
        width 9em
        span 
          display block

</style>